<template>
    <div class="custom-line-input-container">
        <editor-content :editor="editor" />
    </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2';
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import History from '@tiptap/extension-history';

export default {
    name: 'customLineInput',
    components: {
        EditorContent
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        autoFocus: {
            type: Boolean,
            default: false
        }
    },
    
    data() {
        return {
            editor: null,
        };
    },

    watch: {
        disabled(newVal) {
            if (this.editor) {
                this.editor.setOptions({
                    editable: !newVal
                });
            }
        },
    },

    mounted() {
        this.editor = new Editor({
            content: this.value,
            autofocus: this.autoFocus ? 'end' : null,
            extensions: [
                Document,
                Paragraph,
                Text,
                History,
            ],
            editorProps: {
                attributes: {
                    class: 'custom-line-input',
                }
            },
            onUpdate: ({ editor, transaction }) => {
                let htmlValue = editor.getHTML();
                // Limpa paragrafos vazios
                htmlValue = htmlValue.replace(/<p><\/p>/g, '');
                this.$emit('input', htmlValue);
            },
            onBlur: ({ editor, event }) => {
                this.$emit('blur', event);
            }
        })
    },

    beforeDestroy() {
        if (this.editor) {
            this.editor.destroy();
        }
    },
}
</script>

<style scoped>
:deep(.custom-line-input) {
    /* width: min-content; */
    outline: none !important;
    /* display: inline-block; */
    font-size: var(--text-sm);
    line-height: var(--leading-normal);
    background: transparent;
    border: none;
    border-bottom: 1px solid transparent;
    outline: none;
    color: inherit;
    padding: 0;
    margin: 0;
    margin-right: 2px;
    font-family: inherit;
    transition: border-bottom-color 0.2s ease, width 0.1s ease;
}
:deep(.custom-line-input p) {
    margin: 0;
    /* display: inline-block; */
}

:deep(.custom-line-input:not(:disabled)) {
    border-bottom-color: rgba(0, 0, 0, 0.4);
}

:deep(.custom-line-input:not(:disabled):focus) {
    border-bottom-color: rgba(0, 0, 0, 0.8);
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
}

</style>